<div class="container-fluid">
  <page-header-search
    [isSearchInput]="true"
    pageTitleValue="Coupons"
    placeholderValue="Search by coupon name or coupon code..."
    (onHeaderSearchSubmit)="onSearchCoupon($event)"
    [searchString]="searchValue"
  >
  <div class="row mt-3 gt-sm-2">
    <div class="col-12 status-filter-btns">
      <h5 class="filter">Filter By</h5>
      <div class="filter-btn-container">
        <div class="coupon-status">
          <span class="text-muted">Status</span>
          <div class="form-group">
            <input
              type="radio"
              name="status"
              id="status-all"
              value="0"
              [(ngModel)]="choicesObj.statusAll"
              (change)="onStatusBtnChange($event.target.value)"
            />
            <label for="status-all">
              <p class="btn btn-filter">All</p>
            </label>
          </div>
          <div class="form-group">
            <input
              type="radio"
              name="status"
              id="status-active"
              value="true"
              [(ngModel)]="choicesObj.statusActive"
              (change)="onStatusBtnChange($event.target.value)"
            />
            <label for="status-active">
              <p class="btn btn-filter">Active Coupons</p>
            </label>
          </div>
        </div>
        <div class="coupon-domain">
          <span class="text-muted">Type</span>
          <div class="form-group">
            <input
              type="radio"
              name="domain"
              id="domain-all"
              value="0"
              [(ngModel)]="choicesObj.domainAll"
              (change)="onDomainBtnChange($event.target.value)"
            />
            <label for="domain-all">
              <p class="btn btn-filter">All</p>
            </label>
          </div>
          <div class="form-group">
            <input
              type="radio"
              name="domain"
              id="domain-test"
              value="2"
              [(ngModel)]="choicesObj.domainTest"
              (change)="onDomainBtnChange($event.target.value)"
            />
            <label for="domain-test">
              <p class="btn btn-filter">Lab Tests Coupons</p>
            </label>
          </div>
          <div class="form-group">
            <input
              type="radio"
              name="domain"
              id="domain-appointment"
              value="1"
              [(ngModel)]="choicesObj.domainAppointment"
              (change)="onDomainBtnChange($event.target.value)"
            />
            <label for="domain-appointment">
              <p class="btn btn-filter">Appointments Coupons</p>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  </page-header-search>

  <div *ngIf="filteredCouponsArray.length" class="card">
    <div class="card-body">
      <div class="table-title">
        <h3 class="title mb-0">{{ tableTitle }}</h3>
        <a (click)="invertSorting()">
          <span>↑</span>
          <span class="ml--1">↓</span>
          Sort By
        </a>
      </div>
      <ngx-datatable class="material ngx-datatable-custom" [rows]="filteredCouponsArray"
        [columns]="columns" [limit]="pageSize" [offset]="currentPage-1"
        columnMode="force" externalPaging="true" [count]="totalItems" [scrollbarH]="true"
        [headerHeight]="50" [footerHeight]="50" rowHeight="auto" (page)="onChangePage($event)"
        selectionType="single" (select)="handleCouponClick($event)" [messages]="messages">
      </ngx-datatable>
    </div>
  </div>
</div>

<button class="btn-icon-text" (click)="chooseCouponDomain($event)">
  <i class="ni ni-fat-add"></i>
  <span class="btn-text">Create New Coupon</span>
</button>
